module.exports = __webpack_public_path__ + "static/media/tests@2x.408f1e6d.png";